// Lucide icon: download (https://lucide.dev/icons/download)
import { Download } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconDownload = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Download />
    </IconComponentStyled>
  )
}
